export default __webpack_public_path__ + "static/media/duis-button.47463aa5.png";